import {RouteConfig} from 'vue-router/types/router';

/** Pages under /settings (Einstellungen) */
export const SETTINGS_ROUTES: RouteConfig[] = [
    {
        path: '/settings/import',
        name: 'Import',
        component: () => import(/* webpackChunkName: "import" */ '@/views/Import.vue'),
    },
    {
        path: '/settings/teacher-portal',
        name: 'Lehrkraft-Bereich',
        component: () => import(/* webpackChunkName: "teacher-portal-settings" */ '@/views/settings/TeacherPortalSettings.vue'),
    },
    {
        path: '/settings/handout-planning',
        name: 'Austeilplanung',
        component: () => import(/* webpackChunkName: "handout-planning-settings" */ '@/views/settings/HandoutPlanningSettings.vue'),
    },
    {
        path: '/settings/footer',
        name: 'Footer',
        component: () => import(/* webpackChunkName: "footer-config" */ '@/views/settings/FooterSettings.vue'),
    },
    {
        path: '/settings/course-table',
        name: 'Tabellarische Kursübersicht',
        component: () => import(/* webpackChunkName: "course-table" */ '@/views/settings/CourseTable.vue'),
    },
    {
        path: '/settings/referencing',
        name: 'Referenzierung',
        component: () => import(/* webpackChunkName: "referencing-custom-ids" */ '@/views/settings/Referencing.vue'),
    },
    {
        path: '/settings/standing-data',
        name: 'Stammdaten',
        component: () => import(/* webpackChunkName: "standing-data" */ '@/views/settings/StandingData.vue'),
    },
    {
        path: '/settings/permissions',
        component: () => import(/* webpackChunkName: "permissions" */ '@/views/settings/Permissions.vue'),
        children: [
            {
                path: '/',
                name: 'Benutzer und Rollen',
                component: () => import(/* webpackChunkName: "permission-management" */ '@/views/settings/permissions/PermissionOverview.vue'),
            },
            {
                path: 'user/:id',
                name: 'Benutzer',
                component: () => import(/* webpackChunkName: "user-permission-management" */ '@/views/settings/permissions/UserPermissions.vue'),
            },
            {
                path: 'role/:id',
                name: 'Rolle',
                component: () => import(/* webpackChunkName: "role-permission-management" */ '@/views/settings/permissions/RolePermissions.vue'),
            },
        ],
    },
    {
        path: '/settings/auto-permissions',
        component: () => import(/* webpackChunkName: "auto-permissions" */ '@/views/settings/PermissionHooks.vue'),
        children: [
            {
                path: '/',
                name: 'Berechtigungsroutinen',
                component: () => import(/* webpackChunkName: "permission-hooks" */ '@/views/settings/permissionHooks/PermissionHookOverview.vue'),
            },
        ],
    },
    {
        path: '/settings/document-types',
        name: 'Dokumenttypen',
        component: () => import(/* webpackChunkName: "doc-types" */ '@/views/settings/DocumentTypes.vue'),
    },
    {
        path: '/settings/cron-jobs',
        name: 'Automatisierung',
        component: () => import(/* webpackChunkName: "automations" */ '@/views/settings/CronJobs.vue'),
    },
    {
        path: '/settings/applicant-portal',
        name: 'Bewerbungs-Bereich',
        component: () => import(/* webpackChunkName: "applicant-portal-settings" */ '@/views/settings/ApplicantPortalSettings.vue'),
    },
    {
        path: '/settings/communication/senders',
        name: 'Absender & Anlässe',
        component: () => import(/* webpackChunkName: "sender-areas" */ '@/views/settings/SenderAreaSettings.vue'),
    },
    {
        path: '/settings/communication',
        name: 'Kommunikationskanäle',
        component: () => import(/* webpackChunkName: "communication-channels" */ '@/views/settings/CommunicationChannels.vue'),
    },
    {
        path: '/settings/api',
        name: 'APIs und Webhooks',
        component: () => import(/* webpackChunkName: "apis" */ '@/views/settings/APIsView.vue'),
    },
    {
        path: '/settings',
        name: 'Einstellungen',
        component: () => import(/* webpackChunkName: "settings" */ '../views/Settings.vue'),
    },
];
